import Authenticate from '@root/agents.joinroot.com/src/scenes/authenticate';
import BridgeError from '@root/agents.joinroot.com/src/scenes/bridge-error';
import PropTypes from '@root/vendor/prop-types';
import React, { lazy } from '@root/vendor/react';
import noop from '@root/vendor/lodash/noop';
import { Redirect, Route, Switch } from '@root/core/src/components/route';

const WelcomeEntry = lazy(() => import(/* webpackChunkName: "welcome" */ '@root/agents.joinroot.com/src/pages/welcome-entry'));
const PolicyPage = lazy(() => import(/* webpackChunkName: "policy" */ '@root/agents.joinroot.com/src/pages/policy-page'));
const DeeplinkEntry = lazy(() => import(/* webpackChunkName: "policy" */ '@root/agents.joinroot.com/src/pages/deeplink-entry'));
const EstimatedQuoteEntry = lazy(() => import(/* webpackChunkName: "policy" */ '@root/agents.joinroot.com/src/pages/estimated-quote-entry'));
const AccountEntry = lazy(() => import(/* webpackChunkName: "account" */ '@root/agents.joinroot.com/src/pages/account-entry'));
const ProfileEntry = lazy(() => import(/* webpackChunkName: "account" */ '@root/agents.joinroot.com/src/pages/profile-entry'));
const QuoteEntry = lazy(() => import(/* webpackChunkName: "account" */ '@root/agents.joinroot.com/src/pages/quote-entry'));

export default function ProtectedRouter({ onLogout }) {
  return (
    <Switch>
      <Route
        path={'/authenticate'}
        render={() => (
          <Authenticate
            logOut={onLogout}
            setAccessToken={noop}
          />)}
      />
      <Route
        path={'/welcome'}
        render={() => <WelcomeEntry onLogout={onLogout} />}
      />
      <Route
        path={'/deeplink'}
        render={() => <DeeplinkEntry />}
      />
      <Route
        path={'/client/add'}
        render={() => <Redirect to={'/client-account'} />}
      />
      <Route
        path={'/client-account'}
        render={() => <AccountEntry />}
      />
      <Route
        path={'/client-profile'}
        render={() => <ProfileEntry />}
      />
      <Route
        path={'/client-quote'}
        render={() => <QuoteEntry />}
      />
      <Route
        path={'/client-estimated-quote'}
        render={() => <EstimatedQuoteEntry />}
      />
      <Route
        path={'/policy/:policyNumber'}
        render={({ match }) => (
          <PolicyPage
            onLogout={onLogout}
            {...match.params}
          />)}
      />
      <Route
        path={'/bridge-error'}
        render={() => <BridgeError />}
      />
      <Redirect to={'/welcome/policies'} />
    </Switch>
  );
}

ProtectedRouter.propTypes = {
  onLogout: PropTypes.func.isRequired,
  redirectRoute: PropTypes.string,
};
